import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog, DialogTitle, DialogContent, IconButton, CircularProgress, Box
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';
import { formError } from '@utils/helpers';
import PackForm from '@components/pack/PackForm';

function PackEditDialog({ modalOpen, setModalOpen, customerId, type, packId, initialData, onSuccess }) {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const form = useRef();
    const [processing, setProcessing] = useState(false);

    const handleClose = () => {
        setModalOpen(false);
    }

    const handleSubmit = async (data) => {
        try {
            setProcessing(true);
            await API.put(`/customers/${customerId}/packs/${packId}`, data);
            showMessage(t('Credits updated successfully'), 'success');
            setProcessing(false);
            setModalOpen(false);
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            formError(error, t, form.current.setError, showMessage);
            setProcessing(false);
        }
    };

    return (
        <Dialog
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="parent-modal-title"
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {t('Edit {{type}} credits', { type: t(`credit.${type}`) })}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ width: '420px' }}>
                {processing && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress />
                    </Box>
                )}
                <Box sx={{ display: processing ? 'none' : 'block' }}>
                    <PackForm ref={form} initialData={initialData} onSubmit={handleSubmit} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default PackEditDialog; 